// extracted by mini-css-extract-plugin
export default {"companyName":"AboutCompany_companyName__CroZD"};